import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const HorizontalTabsContainer = ({
  leftContainer,
  rightContainer,
  noMargin = false,
}) => (
  <Fragment>
    <div
      className={cn('flex justify-between border-bottom h-20.8', {
        'ml-10': !noMargin,
      })}
    >
      {leftContainer}
      {(rightContainer && (
        <div className="my-auto mr-8.4 ml-auto">{rightContainer}</div>
      )) ||
        null}
    </div>
  </Fragment>
);

HorizontalTabsContainer.propTypes = {
  leftContainer: PropTypes.any.isRequired,
  rightContainer: PropTypes.any,
};

HorizontalTabsContainer.defaultProps = {
  rightContainer: null,
};

export default HorizontalTabsContainer;
